import { render, staticRenderFns } from "./informationPop.vue?vue&type=template&id=aab8cf14&scoped=true&"
import script from "./informationPop.vue?vue&type=script&lang=js&"
export * from "./informationPop.vue?vue&type=script&lang=js&"
import style0 from "./informationPop.vue?vue&type=style&index=0&id=aab8cf14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab8cf14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab8cf14')) {
      api.createRecord('aab8cf14', component.options)
    } else {
      api.reload('aab8cf14', component.options)
    }
    module.hot.accept("./informationPop.vue?vue&type=template&id=aab8cf14&scoped=true&", function () {
      api.rerender('aab8cf14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/tdc-cardholder-change/modules/informationPop.vue"
export default component.exports